import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import Store from '@redux';

import CalqResults from './CalqResults';

const CalqResultsStateContainer = ({
  filtersOptions,
}) => {
  const store = Store.get();

  return (
    <Provider store={store}>
      <CalqResults
        filtersOptions={filtersOptions}
      />
    </Provider>
  );
};

CalqResultsStateContainer.propTypes = {
  filtersOptions: PropTypes.shape({
    otherResourceCategoryFilters: PropTypes.arrayOf(PropTypes.object),
    practiceAreaFilters: PropTypes.arrayOf(PropTypes.object),
    publicationFilters: PropTypes.arrayOf(PropTypes.object),
    resourceTypeFilters: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

CalqResultsStateContainer.displayName = 'CalqResultsStateContainer';

export default CalqResultsStateContainer;
